import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Badge,
  Btn,
  ConfirmDialog,
  CustomCalendar,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  HeaderText,
  InputDate,
  InputNumeroInteiro,
  InputText,
  InputTime,
  PageHeader,
  TextBtn,
} from '../../../../../components'
import React, { useEffect, useRef } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useMovimentacaoEstoqueAvulso, { LOAD_MESSAGE } from './MovimentacaoEstoqueAvulsoHook'
import * as colors from '../../../../../assets/js/colors'
import ModalMovimentacaoEstoqueAvulso from './ModalMovimentacaoEstoqueAvulso'
import ModalMovimentacaoEstoqueAvulsoRelatorio from './ModalMovimentacaoEstoqueAvulsoRelatorio'
import { isRouteAllowed } from '../../../../../services/permission/menus'

function MovimentacaoEstoqueAvulso({ dispatch, history, selectedTp }) {
  if (!isRouteAllowed(44))
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <h1>Você não tem acesso a esta funcionalidade</h1>
      </div>
    )
  const { state, localDispatch } = useMovimentacaoEstoqueAvulso()
  const justificativaRef = useRef(null)

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutosFromCompany(state.selectedEmpresa)
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.POSICOES_SAIDA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesWhereProdutoIn(selectedTp, state.selectedProdutoSaida)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const optionTemplate = option => {
    return (
      <div style={{ display: 'flex' }}>
        <span style={{ float: 'right', margin: '.5em .25em 0 0' }}>{option.name}</span>
        <BadgeTypeOperacoesEstoque status={option.type} />
      </div>
    )
  }

  return (
    <div>
      <PageHeader>8.6 - Movimentações de Estoque - Avulso</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecione uma Operação"
                optionLabel={'name'}
                options={state.operacoes}
                itemTemplate={option => optionTemplate(option)}
                label={'Operação de Estoque'}
                onChange={value => localDispatch.onChange('selectedOperacao', value)}
                value={state.selectedOperacao}
              />
            </div>
            <div className="p-col-2">
              <CustomCalendar
                label={'Data da Movimentação'}
                onChange={value => localDispatch.onChange('dataMovimentacao', value)}
                value={state.dataMovimentacao}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: -10 }}>
              <InputTime
                label={'Hora da Movimentação'}
                value={state.horaMovimentacao}
                onChange={value => localDispatch.onChange('horaMovimentacao', value)}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecione uma Empresa"
                optionLabel={'name'}
                filter={true}
                options={state.empresas}
                label={'Empresa'}
                onChange={value => localDispatch.onChange('selectedEmpresa', value)}
                value={state.selectedEmpresa}
              />
            </div>
            <div className="p-col-2">
              {state.selectedOperacao && state.selectedOperacao.type === 'Entrada' && (
                <CustomDropdown
                  placeholder="Selecione um Estoque"
                  optionLabel={'name'}
                  options={state.estoques}
                  label={'Estoque'}
                  onChange={value => localDispatch.onChange('selectedEstoque', value)}
                  value={state.selectedEstoque}
                />
              )}
            </div>
            <div className="p-col-6">
              <InputText
                label="Justificativa (opcional)"
                placeholder="Justificativa do lançamento avulso"
                value={state.justificativa}
                onChange={value => localDispatch.onChangeJustificativa(value)}
                marginTop={25}
                ref={justificativaRef}
              />
            </div>
          </div>
          <div className="p-grid">
            {state.selectedOperacao && state.selectedOperacao.type === 'Entrada' ? (
              <TablesOperacaoEntrada
                state={state}
                localDispatch={localDispatch}
                selectedTp={selectedTp}
                justificativaRef={justificativaRef}
              />
            ) : state.selectedOperacao && state.selectedOperacao.type === 'Saída' ? (
              <TablesOperacaoSaida
                state={state}
                localDispatch={localDispatch}
                justificativaRef={justificativaRef}
              />
            ) : null}
          </div>
        </CustomPanel>
      </div>
      <ModalMovimentacaoEstoqueAvulso
        isVisible={state.modal.show}
        movimentacoes={state.modal.data}
        onClose={localDispatch.onCloseModal}
        onRemove={localDispatch.onClickRemoverMovimentacao}
      />
      <ModalMovimentacaoEstoqueAvulsoRelatorio
        dispatch={dispatch}
        selectedTp={selectedTp}
        isVisible={state.showModalRelatorio}
        onClose={localDispatch.onCloseModalRelatorio}
        operacoes={state.operacoes}
      />
      <ConfirmDialog
        isVisible={state.showDialogExpedir}
        title="Atenção"
        content={
          <span>
            Essa operação não poderá ser desfeita!<br></br>Confirmar a expedição ?
          </span>
        }
        onCancelar={() => localDispatch.onChange('showDialogExpedir', false)}
        onOk={() => {
          const justificativaAtual =
            (justificativaRef && justificativaRef.current && justificativaRef.current.value) ||
            state.justificativa
          localDispatch.onExpedir(
            state.selectedPosicoes,
            state.selectedProdutoSaida,
            state.dataMovimentacao,
            state.horaMovimentacao,
            state.selectedOperacao,
            selectedTp,
            justificativaAtual,
          )
        }}
      />
    </div>
  )
}

const TablesOperacaoEntrada = ({ state, localDispatch, selectedTp, justificativaRef }) => {
  return (
    <>
      <div className="p-col-6">
        <HeaderText>Listagem de Produtos</HeaderText>
        <DataTable
          value={state.produtos}
          header={
            <CustomDataTableHeader
              onChange={value => localDispatch.onChange('globalFilter', value)}
              children={
                <div
                  style={{
                    display: 'inline-grid',
                    gap: '10px',
                    gridAutoFlow: 'column',
                    marginLeft: 20,
                  }}
                >
                  <Btn
                    onClick={() =>
                      localDispatch.onClickAlocar(state.selectedProduto, state.selectedPosicoes)
                    }
                  >
                    Alocar
                  </Btn>
                </div>
              }
            />
          }
          selection={state.selectedProduto}
          onSelectionChange={e => localDispatch.onChange('selectedProduto', e.value)}
          globalFilter={state.globalFilter}
          paginator={true}
          rows={10}
          emptyMessage="Nenhum produto para exibir"
        >
          <Column selectionMode="single" style={{ width: '5em' }} />
          <Column field="product_code" header="Código" style={tableCellCentered(80)} />
          <Column field="name" header="Produto" style={tableCellCentered(200)} />
          <Column
            header="Operações"
            body={data => (
              <TextBtn onClick={() => localDispatch.onOpenModal(data)} color={colors.azul_escuro}>
                {data.movimentacoes}
              </TextBtn>
            )}
            style={tableCellCentered(100)}
          />
          <Column
            style={tableCellCentered(80)}
            field="qte_alocar"
            header="Qte Para Alocar"
            body={produto => (
              <InputNumeroInteiro
                marginTop={0}
                value={produto.qte_alocar}
                onChange={value => localDispatch.onChangeProduto(produto.id, value, 'qte_alocar')}
              />
            )}
          />
          <Column
            style={tableCellCentered(120)}
            field="validade"
            header="Validade"
            body={produto => (
              <InputDate
                marginTop={0}
                value={produto.validade ? produto.validade : ''}
                onChange={value => localDispatch.onChangeProduto(produto.id, value, 'validade')}
              />
            )}
          />
          <Column
            style={tableCellCentered(100)}
            field="lote"
            header="Lote"
            body={produto => (
              <InputText
                marginTop={0}
                value={produto.lote ? produto.lote : ''}
                onChange={value => localDispatch.onChangeProduto(produto.id, value, 'lote')}
              />
            )}
          />
        </DataTable>
      </div>
      <div className="p-col-6">
        <HeaderText>Posições de Estoque</HeaderText>
        <DataTable
          value={state.posicoes}
          header={
            <CustomDataTableHeader
              onChange={value => localDispatch.onChange('globalFilterPosicao', value)}
              children={
                <div
                  style={{
                    display: 'inline-grid',
                    gap: '10px',
                    gridAutoFlow: 'column',
                    marginLeft: 20,
                  }}
                >
                  <Btn
                    onClick={() => {
                      const justificativaAtual =
                        (justificativaRef &&
                          justificativaRef.current &&
                          justificativaRef.current.value) ||
                        state.justificativa
                      localDispatch.onChangeJustificativa(justificativaAtual)
                      localDispatch.onClickConcluir(
                        state.posicoes,
                        state.dataMovimentacao,
                        state.horaMovimentacao,
                        state.selectedOperacao,
                        selectedTp,
                        justificativaAtual,
                      )
                    }}
                  >
                    Concluir
                  </Btn>
                </div>
              }
            />
          }
          selection={state.selectedPosicoes}
          onSelectionChange={e => localDispatch.onChange('selectedPosicoes', e.value)}
          globalFilter={state.globalFilterPosicao}
          paginator={true}
          rows={10}
          rowClassName={rowData => ({ 'row-alocated': rowData.alocated })}
          emptyMessage="Nenhuma posição a ser exibida"
          removableSort={true}
        >
          <Column selectionMode="multiple" style={{ width: '3em' }} />
          <Column field="endereco" header="Endereço" sortable={true} />
          <Column field="capacidade" header="Capacidade em pallets" style={tableCellCentered()} />
          <Column field="caixas" header="Caixas na posição" style={tableCellCentered()} />
          <Column
            field="caixas_novas"
            header="Caixas a serem inseridas"
            style={tableCellCentered()}
          />
        </DataTable>
      </div>
    </>
  )
}

const TablesOperacaoSaida = ({ state, localDispatch, justificativaRef }) => {
  return (
    <>
      <div className="p-col-6">
        <DataTable
          value={state.produtos}
          header={
            <CustomDataTableHeader
              onChange={value => localDispatch.onChange('globalFilter', value)}
            />
          }
          selection={state.selectedProdutoSaida}
          onSelectionChange={e => localDispatch.onChange('selectedProdutoSaida', e.value)}
          globalFilter={state.globalFilter}
          paginator={true}
          rows={10}
          emptyMessage="Nenhum produto para exibir"
        >
          <Column selectionMode="single" style={{ width: '5em' }} />
          <Column field="product_code" header="Código" style={tableCellCentered(130)} />
          <Column field="name" header="Produto" style={{ textAlign: 'center' }} />
        </DataTable>
      </div>
      <div className="p-col-6">
        <DataTable
          value={state.posicoesSaida}
          header={
            <CustomDataTableHeader
              onChange={value => localDispatch.onChange('globalFilterPosicao', value)}
              children={
                <div
                  style={{
                    display: 'inline-grid',
                    gap: '10px',
                    gridAutoFlow: 'column',
                    marginLeft: 20,
                  }}
                >
                  <Btn
                    onClick={() => {
                      const justificativaAtual =
                        (justificativaRef &&
                          justificativaRef.current &&
                          justificativaRef.current.value) ||
                        state.justificativa
                      localDispatch.onChangeJustificativa(justificativaAtual)
                      localDispatch.onClickExpedir(
                        state.selectedPosicoes,
                        state.posicoesSaida,
                        justificativaAtual,
                      )
                    }}
                  >
                    Expedir
                  </Btn>
                </div>
              }
            />
          }
          selection={state.selectedPosicoes}
          onSelectionChange={e => localDispatch.onChange('selectedPosicoes', e.value)}
          globalFilter={state.globalFilterPosicao}
          paginator={true}
          rows={10}
          rowClassName={rowData => ({ 'row-alocated': rowData.delete })}
          emptyMessage="Nenhuma posição a ser exibida"
          removableSort={true}
        >
          <Column selectionMode="multiple" style={{ width: '3em' }} />
          <Column field="estoque_name" header="Estoque" sortable={true} />
          <Column field="endereco" header="Endereço" sortable={true} />
          <Column field="validade" header="Validade" />
          <Column field="lote" header="Lote" />
          <Column field="quantidade" header="Quantidade" />
          <Column
            field="qte_alocar"
            header="Qte Para Expedir"
            body={posicao => (
              <InputNumeroInteiro
                marginTop={0}
                allowNegative={false}
                decimalScale={2}
                value={posicao.qte_remover}
                onChange={value => localDispatch.onChangePosicao(posicao.id, value, 'qte_remover')}
              />
            )}
          />
        </DataTable>
      </div>
    </>
  )
}

export function BadgeTypeOperacoesEstoque({ status }) {
  switch (status) {
    case 'Entrada':
      return <Badge color={colors.verde}>{status}</Badge>
    case 'Saída':
      return <Badge color={colors.vermelho}>{status}</Badge>
    default:
      return <Badge color={colors.laranja}>Erro</Badge>
  }
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoEstoqueAvulso))
